import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomSnackbarContentComponent } from './rds-utilities/snackbar.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [CustomSnackbarContentComponent],
  imports: [
    CommonModule,
	MatIconModule,
	MatButtonModule
  ],
  exports: [],
  entryComponents:[CustomSnackbarContentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RedfoxDesignSystemModule { 
  public static forRoot(environment: any): ModuleWithProviders {

		return {
			ngModule: RedfoxDesignSystemModule,
			providers: [
				{
					provide: 'env', // you can also use InjectionToken
					useValue: environment
				}
			]
		};
	}
}
